var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.796,
    height: 30.964,
    viewBox: "0 0 42.796 30.964",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-youtube",
    "data-name": "Icon feather-youtube",
    transform: "translate(-22.592 -20.971)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103091",
    "data-name": "Path 103091",
    d: "M40.462,10.377A5.029,5.029,0,0,0,36.953,6.76C33.842,6,21.4,6,21.4,6S8.953,6,5.841,6.832A5.029,5.029,0,0,0,2.332,10.45,52.456,52.456,0,0,0,1.5,20.018a52.456,52.456,0,0,0,.832,9.641,5.029,5.029,0,0,0,3.509,3.473c3.111.832,15.556.832,15.556.832s12.445,0,15.556-.832a5.029,5.029,0,0,0,3.509-3.618,52.455,52.455,0,0,0,.832-9.5,52.455,52.455,0,0,0-.832-9.641Z",
    transform: "translate(22.593 16.471)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103092",
    "data-name": "Path 103092",
    d: "M14.625,24.55l10.4-5.915-10.4-5.915Z",
    transform: "translate(25.295 17.854)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.486a466c359527d9158dbb8dabc7bd1f.svg";
export { ForwardRef as ReactComponent };